import React from "react";
import _ from "lodash";
import moment from "moment";
import submit from "submit-form";
import getDayRangeString from "../../../utils/day-range-string";
import Chart from "../../../parts/chart";
import DateInput from "../../../parts/inputs/date-input";
import ToggleLinksInput from "../../../parts/inputs/toggle-links-input";
import ShareModal from "../../../parts/modals/share";
import MetricsFoot from "./MetricsFoot";
import MetricsBackButton from "./metrics-back-button";
import set from "@rill/set";

import { PRIMARIES, DATE_FORMATS } from "../../../constants";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const { DATE_PICKER_FORMAT } = DATE_FORMATS;

function View(props, { locals }) {
  const { competitionsVolume, activeCompetitionsVolume, query, search } =
    locals;
  const { primary, type, units, athlete } = query;
  const organizationCoach = query.organizationCoach || undefined;

  const selectedCompetitions = type
    ? _.filter(activeCompetitionsVolume, { type })
    : [];
  const types = _(competitionsVolume).map("type").sort().uniq().value();
  const keys = _(selectedCompetitions)
    .map("date")
    .sort()
    .map((k) => moment.utc(k).startOf("day").toJSON())
    .uniq()
    .value();
  const labels = _.map(keys, (k) => moment.utc(k).format("MMM D/YY"));

  const selectedPrimaries = primary === "total" ? PRIMARIES : [primary];
  const seriesTotals = _.map(selectedPrimaries, (name) => {
    return {
      name,
      className: name,
      data: _.map(keys, (k) => {
        const competition = _.find(
          _.sortBy(selectedCompetitions, "date"),
          ({ date }) => {
            return moment.utc(date).startOf("day").isSame(moment.utc(k));
          }
        );
        const attempts = _.get(competition, ["attempts", [name]], []);
        return locals.fromMetric(_.max(attempts.concat(0.1)), units, false);
      }),
    };
  });
  const seriesWilks = _.map(keys, (k) => {
    const competition = _.find(
      _.sortBy(selectedCompetitions, "date"),
      ({ date }) => {
        return moment.utc(date).startOf("day").isSame(moment.utc(k));
      }
    );

    return _.get(competition, "wilks", 0);
  });

  const totalVolumes = _.map(keys, (k, i) =>
    _.sum(_.map(seriesTotals, `data.${i}`))
  );
  const maxVolume = _.max(totalVolumes);
  const maxWilks = _.max(seriesWilks);

  return (
    <div className="Main Metrics">
      <MetricsBackButton url={`/athlete-portal/metrics/${search}`} />
      <h1 className="competition-history alt">Competition History</h1>
      <span className="description">
        Analyze your performance from each competition, including totals and
        Wilks, and compare with past results.
      </span>

      <form id="metrics-form" action="#_" method="GET" data-noreset>
        <input type="hidden" name="athlete" value={locals.athlete._id}></input>
        <input
          type="hidden"
          name="organizationCoach"
          value={organizationCoach ? organizationCoach : ""}
        ></input>
        <div className="Competition-Selector">
          <span className="label">Competition Type</span>
          <select
            onChange={() => submitForm(athlete)}
            name="type"
            className="select-input"
            id="competition-form-type"
            defaultValue={type}
          >
            <option value="">Select a type</option>
            {_.map(types, (type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        <div className="Date-Range">
          <div className="left-side">
            <span className="label">Reporting Period</span>
            <DateInput
              name="start"
              placeholder="Start Date"
              value={query.start}
              max={query.end}
              onChange={() => submitForm(athlete)}
              id="competition-form-start"
            />
            <i>to</i>
            <DateInput
              name="end"
              placeholder="End Date"
              value={query.end}
              min={query.start}
              onChange={() => submitForm(athlete)}
              id="competition-form-end"
            />
            <input type="submit" style={{ opacity: 0, position: "absolute" }} />
          </div>
        </div>

        <div className="Chart-Frame bar-chart">
          <div className="head">
            <div className="right-side">
              <div className="group">
                <ToggleLinksInput
                  name="units"
                  id="competition-form-units"
                  options={[
                    { text: "Kg", value: "metric" },
                    { text: "Lbs", value: "imperial" },
                  ]}
                />
              </div>
            </div>

            <div className="left-side">
              <div className="group">
                {!_.includes(type, "Bench Only") && (
                  <ToggleLinksInput
                    className="tabs"
                    name="primary"
                    id="competition-form-primary"
                    options={[
                      { text: "Total", value: "total" },
                      { text: "Squat", value: "squat" },
                      { text: "Bench", value: "bench" },
                      { text: "Deadlift", value: "deadlift" },
                    ]}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="body">
            {!type ? (
              <div className="content">Please select a competition type.</div>
            ) : (
              !_.isEmpty(selectedCompetitions) && (
                <div>
                  <div className="legend">
                    <div className="line series-a">Wilks</div>
                  </div>
                  <div className="axis-labels">
                    <div className="left">Total</div>
                    <div className="right">Wilks</div>
                  </div>
                  <div className="chart-fullsize">
                    <div className="labels">
                      <Chart
                        type="Bar"
                        only="label"
                        data={{ series: seriesTotals }}
                        options={{
                          width: "60px",
                          height: "380px",
                          stackBars: true,
                          axisX: { showGrid: false, showLabel: false },
                          axisY: {
                            showGrid: false,
                            showLabel: true,
                            scaleMinSpace: 30,
                            onlyInteger: true,
                            high: maxVolume,
                            low: 0,
                          },
                        }}
                      />

                      <Chart
                        type="Bar"
                        only="label"
                        data={{ series: [seriesWilks] }}
                        options={{
                          width: "60px",
                          height: "380px",
                          axisX: { showGrid: false, showLabel: false },
                          axisY: {
                            showGrid: false,
                            showLabel: true,
                            onlyInteger: true,
                            scaleMinSpace: 30,
                            high: maxWilks,
                            low: 0,
                          },
                        }}
                      />
                    </div>

                    <div className="data">
                      <Chart
                        type="Bar"
                        data={{
                          labels: labels,
                          series: seriesTotals,
                        }}
                        options={{
                          width: `${_.size(labels) * 40}px`,
                          height: "380px",
                          stackBars: true,
                          seriesBarDistance: 20,
                          chartPadding: { left: 35, right: 75 },
                          axisX: { showGrid: false, showLabel: true },
                          axisY: {
                            showGrid: true,
                            showLabel: false,
                            scaleMinSpace: 30,
                          },
                        }}
                        tooltip={(item, i) => {
                          if (totalVolumes[i] <= 0.4) return;
                          const key = keys[i];
                          const date = moment.utc(key);
                          const dayRange = getDayRangeString([date, date]);
                          return (
                            <div className="tooltip" style={{ left: item.x }}>
                              <div className="details">
                                <div>
                                  <b>{dayRange}</b>
                                </div>
                                <div>
                                  Wilks <b>{seriesWilks[i]}</b>
                                </div>
                                {_.compact(
                                  _.map(seriesTotals, ({ name, data }, it) => {
                                    if (!data[i] || data[i] === 0.1) return;
                                    return (
                                      <div key={name}>
                                        {_.capitalize(name)}{" "}
                                        <b>
                                          {locals.withWeight(
                                            _.round(data[i], 1),
                                            units
                                          )}
                                        </b>{" "}
                                        {_.round(
                                          (data[i] / totalVolumes[i]) * 100,
                                          1
                                        )}
                                        %
                                      </div>
                                    );
                                  })
                                )}
                              </div>
                            </div>
                          );
                        }}
                      />

                      {_.size(labels) >= 2 && (
                        <Chart
                          type="Line"
                          data={{ series: [seriesWilks] }}
                          options={{
                            width: `${_.size(labels) * 40}px`,
                            height: "380px",
                            showPoint: false,
                            chartPadding: { left: 35, right: 75 },
                            axisX: { showGrid: false, showLabel: false },
                            axisY: {
                              scaleMinSpace: 30,
                              onlyInteger: true,
                              showGrid: false,
                              showLabel: false,
                              high: maxWilks,
                              low: 0,
                            },
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>

        <MetricsFoot
          supportHref="/dashboard/support/videos?video=WNvTFol9eNs"
          shareHref="/actions/refresh?modal[type]=share"
        />
      </form>
    </div>
  );
}

function submitForm(athlete) {
  const start = document.getElementById("competition-form-start").value;
  const end = document.getElementById("competition-form-end").value;
  const type = document.getElementById("competition-form-type").value;
  // const primary = document.getElementById("competition-form-primary").value;
  // const units = document.getElementById("competition-form-units").value;
  submit("#_", {
    body: {
      start,
      end,
      type,
      // primary,
      // units,
      athlete,
    },
  });
}

const CompetitionHistory = (app) => {
  app.get(
    "/competition-history",
    set("heading", "Competition History"),
    async ({ req, res, load, locals, api, fail, momentTZ }) => {
      const { query } = req;

      _.defaults(req.query, {
        primary: "total",
        units: locals.units,
        start: moment.utc(0).format(DATE_PICKER_FORMAT),
        end: moment.utc().endOf("month").format(DATE_PICKER_FORMAT),
      });

      await Promise.all([
        load("competitionsVolume", {
          proxyAthlete: query.athlete,
          reqSource: "metrics",
        }),
      ]);
      query.start = moment.utc(query.start, DATE_PICKER_FORMAT).startOf("day");
      query.end = moment.utc(query.end, DATE_PICKER_FORMAT).endOf("day");

      // Filter out competitions based on query dates.
      locals.activeCompetitionsVolume = _.sortBy(
        _.filter(locals.competitionsVolume, (competition) => {
          const date = moment.utc(competition.date);
          return (
            (!query.start.isValid() || date.isSameOrAfter(query.start)) &&
            (!query.end.isValid() || date.isSameOrBefore(query.end))
          );
        }),
        "date"
      );

      const modal = _.get(query, "modal", {});

      if (modal.type === "share" && !modal.snapshot) {
        // create share link
        try {
          modal.snapshot = (
            await (
              await api("snapshot", {
                method: "POST",
                user: {
                  name: locals.athlete.name,
                  registered: locals.athlete.registered,
                  avatar: locals.athlete.avatar,
                  units: locals.athlete.units,
                },
                body: {
                  type: "competition-history",
                  data: JSON.stringify(
                    _.chain(locals)
                      .pick(["activeCompetitionsVolume"])
                      .assign(_.pick(query, ["start", "end", "type"]))
                      .value()
                  ),
                },
              })
            ).json()
          )._id;

          modal.date = getDayRangeString([
            moment.utc(query.start, DATE_PICKER_FORMAT),
            moment.utc(query.end, DATE_PICKER_FORMAT),
          ]);
          return res.refreshWith({ modal });
        } catch (e) {
          console.error(e.stack || e);
          fail(400, "Error creating share link.");
        }
      }

      locals.modal = {
        share: <ShareModal />,
        "activity-feed": <ActivityDrawer />,
      }[modal.type];

      res.body = <View />;
    }
  );
};

export default CompetitionHistory;
